import { Container } from '@components/Container'
import { Loading } from '@components/Loading'
import { campaignTypeLabel } from '@interfaces/promotionCampaign/CampaignTypeEnum'
import { CampaignForm } from '../../components/CampaignForm/CampaignForm'
import { EditCampaignPageProps } from './interface'

export function EditCampaignPage({
  campaignType,
  initialValues,
  isLoading,
  handleSubmit,
  handleLeave,
}: EditCampaignPageProps) {
  return (
    <Container>
      {!isLoading ? (
        <CampaignForm
          initialValues={initialValues}
          campaignType={campaignType}
          title={`แก้ไขแคมเปญ - ${campaignTypeLabel[campaignType]}`}
          handleSubmit={handleSubmit}
          goBackHandle={handleLeave}
        />
      ) : (
        <Loading size={36} className='m-auto' />
      )}
    </Container>
  )
}
